// SignupStep3.jsx — Password
import React, { useState } from "react";

function passwordStrengthError(password) {
  if (!password || password.length < 8) return "Password must be at least 8 characters.";
  if (!/[A-Z]/.test(password)) return "Password must include an uppercase letter.";
  if (!/[0-9]/.test(password)) return "Password must include a number.";
  return null;
}

// Password input with an eye button to show / hide what's typed
const PasswordInput = ({ name, value, onChange, placeholder }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <input
        type={visible ? "text" : "password"}
        className="form-control"
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete="new-password"
        style={{ paddingRight: 42 }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          top: "50%",
          right: 10,
          transform: "translateY(-50%)",
          border: "none",
          background: "none",
          padding: 4,
          cursor: "pointer",
          color: "#888780",
          lineHeight: 1,
        }}
      >
        <i className={visible ? "fa fa-eye-slash" : "fa fa-eye"} aria-hidden="true"></i>
      </button>
    </div>
  );
};

const Step3 = ({ formData, setFormData, nextStep, prevStep }) => {
  const [showError, setShowError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const pwError = passwordStrengthError(formData.password);
  const passwordsMatch = formData.password && formData.password === formData.confirmPassword;
  const canContinue = !pwError && passwordsMatch;

  const handleContinue = () => {
    if (!canContinue) {
      setShowError(true);
      return;
    }
    nextStep();
  };

  return (
    <div className="step3">
      <div className="left-icon1">
        <button type="button" className="backbutton" onClick={prevStep}>
          <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
        </button>
      </div>
      <div className="icon-blk text-center">
        <img src="images/profile-icon.svg" alt="Profile" />
      </div>
      <div className="form-basic">
        <h5 className="modal-title">Create a password</h5>

        <div className="mb-3">
          <PasswordInput
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="At least 8 characters"
          />
        </div>

        <div className="mb-3">
          <PasswordInput
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder="Confirm password"
          />
        </div>

        {showError && pwError && (
          <p style={{ color: "#B3261E", fontSize: 12.5, marginTop: -6 }}>{pwError}</p>
        )}
        {showError && !pwError && !passwordsMatch && (
          <p style={{ color: "#B3261E", fontSize: 12.5, marginTop: -6 }}>Passwords don't match.</p>
        )}

        <div className="modal-footer border-0 justify-content-center p-0 footer-modal mt-4">
          <button type="button" className="py-2 btn-filled" onClick={handleContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step3;